"use client"

import { ArrowUpToLine } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowUpToLineIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowUpToLineIcon = component(Icon)({ as: ArrowUpToLine })
